import { DrawIcon } from './DrawIcon';

/**
 * author: Michael Irigoyen
 * id ECDE04BF-F8A5-4DAD-B4F9-887CAE97CBE3
 * name draw
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/draw.svg
 * tags
 * - Drawing / Art 
 * - Form 
 */
export const SignIcon = DrawIcon;
export default SignIcon